import {
  createStyleSheet,
  flexMixin,
  GlobalThemeInterface,
  headerHeight,
  maxContainerWidth,
  vh,
} from '@groma-dev/blueprint';
import { maxContainerMobileWidth } from '../../../utils/StyleContants';

export const getAppStyles = createStyleSheet(
  (theme: GlobalThemeInterface) => ({
    appContainer: {
      alignItems: 'center',
      backgroundColor: theme.colors.$background100,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxWidth: '100%',
      minHeight: vh(),
      minWidth: '100%',
      width: '100%',
    },
    appWrapper: {
      ...flexMixin('column'),
      minHeight: vh(),
      width: '100%',
    },
    mainContainer: {
      ...flexMixin('column'),
      flex: '1 1 100%',
      height: '100%',
      width: '100%',
    },
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      margin: '0 auto',
      minHeight: `calc(100vh - ${headerHeight}px)`,
      position: 'relative',
      scrollMarginTop: `${headerHeight}px`,
      width: '100%',
    },
    appHeader: {
      borderBottom: `1px solid ${theme.colors.$primary300}`,
    },
    intro: {
      marginInline: 'auto',
      maxWidth: maxContainerWidth,
      padding: `${theme.spacing.$s7} 120px`,
      width: '100%',
    },
    introTitle: {
      ...theme.typography.$textPrimary450,
    },
    introMessage: {
      ...theme.typography.$textPrimary100,
      maxWidth: '520px',
      marginTop: theme.spacing.$s3,
    },
    [`@media (max-width: ${theme.breakpoints.$md}px)`]: {
      intro: {
        maxWidth: maxContainerMobileWidth,
        padding: `${theme.spacing.$s5} ${theme.spacing.$s3} ${theme.spacing.$s4}`,
      },
      introTitle: {
        ...theme.typography.$textPrimary350,
      },
      introMessage: {
        ...theme.typography.$textPrimary000,
        marginTop: theme.spacing.$s3,
      },
    },
    [`@media (max-width: ${theme.breakpoints.$xs}px)`]: {
      intro: {
        maxWidth: 'unset',
      },
    },
  }),
  { name: 'App' }
);
